import UserSessionService from "./UserSessionService";
import WsService from "./WsService";
import Currency from "../domain/Currency";


const ENDPOINT_BASE = "/transactions/currency";

export default class CurrencyService {

    static retrieveCurrenciesForPayoutPartner(payoutPartnerId) {

        let endpoint = ENDPOINT_BASE + "?payout-partner-id=" + payoutPartnerId;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let responseArr = [];
                response.forEach(singleResponse => {
                    responseArr.push(new Currency(singleResponse))
                });
                return responseArr;
            },
            response => {
                return response;
            }
        )

    }

}